import React from 'react';
import styles from './SustainabilityStartModal.module.scss';
import { Button, Modal } from 'tt-ui-lib/core';

const TITLE = 'Start GHG Report';
const MESSAGE =
  'We offer the following options for entering information. Note that automated data extraction is a paid for option. Price for data extraction varies depending on the volume of the uploaded documents.';
const BUTTON_TEXT = 'Start';

const data = [
  {
    header: 'Manual entry (free)',
    text: 'You can manually type your answers in the text boxes related to each question.',
    entryType: 'manual',
  },
  {
    header: 'Automated entry (fee is charged for data extraction)',
    text: 'You can upload one or more documents in connection with each question and our AI model will generate answers on their basis. Once generated you can edit the answers manually.',
    disabled: true,
    entryType: 'automated',
  },
  {
    header: 'Bulk upload (fee is charged for data extraction and data processing)',
    text: 'You can upload a pool of documents containing information relevant to different questions and our AI model will generate answers on their basis and distribute them to the relevant questions. Once generated you can edit the answers manually.',
    disabled: true,
    entryType: 'bulk',
  },
];

const SustainabilityStartModal = (props) => {
  const { open, onClose, onFinish, title, message, buttonText } = props;

  const startReport = (index) => {
    onFinish(data[index].entryType);
    onClose(false);
  };

  const getKey = (index) => `${title}${index}`;
  return (
    <>
      <Modal
        open={open}
        onClose={() => onClose(true)}
        onClick={(e) => e.stopPropagation()}
        title={title ?? TITLE}
        className={styles.startModal}
      >
        <div>{message ?? MESSAGE}</div>
        <div className={styles.panelBlock}>
          {data.map((item, index) => (
            <div key={getKey(index)} className={styles.panelItem}>
              <div className={styles.itemHeader}>{item.header}</div>
              <div className={styles.itemText}>{item.text}</div>
              <Button
                type="primary"
                onClick={() => startReport(index)}
                className={styles.itemButton}
                disabled={item.disabled}
              >
                {item.disabled ? 'TO BE SOON' : buttonText ?? BUTTON_TEXT}
              </Button>
            </div>
          ))}
        </div>
      </Modal>
    </>
  );
};

export default SustainabilityStartModal;
